import { render, staticRenderFns } from "./venueList.vue?vue&type=template&id=408c9bd8&scoped=true"
import script from "./venueList.vue?vue&type=script&lang=js"
export * from "./venueList.vue?vue&type=script&lang=js"
import style0 from "./venueList.vue?vue&type=style&index=0&id=408c9bd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408c9bd8",
  null
  
)

export default component.exports